module.exports = __webpack_public_path__ + "static/media/book15.ec4dbd90.jpg";